import { API } from "@/App";

/**
 * Helper function to get full image URL from relative or absolute paths
 * Handles /api/uploads/ relative paths by prepending the backend URL
 * @param {string} url - The image URL (can be relative or absolute)
 * @returns {string|null} - Full URL or null if no URL provided
 */
export const getImageUrl = (url) => {
  if (!url) return null;
  
  // If already a full URL, return as is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // If relative URL starting with /api, prepend backend URL
  if (url.startsWith('/api/')) {
    const backendUrl = API.replace('/api', '');
    return `${backendUrl}${url}`;
  }
  
  // If it starts with just / (other relative paths), also prepend backend
  if (url.startsWith('/')) {
    const backendUrl = API.replace('/api', '');
    return `${backendUrl}${url}`;
  }
  
  return url;
};

/**
 * Default fallback image for players
 */
export const DEFAULT_PLAYER_IMAGE = 'https://images.unsplash.com/photo-1566577739112-5180d4bf9390?w=400';

/**
 * Default fallback image for coaches
 */
export const DEFAULT_COACH_IMAGE = 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400';

/**
 * Default fallback image for merchandise
 */
export const DEFAULT_MERCH_IMAGE = 'https://images.unsplash.com/photo-1523381210434-271e8be1f52b?w=400';
